import React, {useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import axios from 'axios';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';

const SDM_PAY_HOST = process.env.REACT_APP_SDM_PAY_BE
function WithdrawalStatusUpdateDialog({open, handleClose, withdrawalRequest, update, setUpdate}: any) {
    const [updatedStatus, setUpdatedStatus] = useState('');
    const [reference, setReference] = useState('');
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        console.log(withdrawalRequest)
        setUpdatedStatus(withdrawalRequest.status)
    },[withdrawalRequest])
    const handleChange = (event: SelectChangeEvent) => {
        setUpdatedStatus(event.target.value);
    };
    const onConfirmStatusChange = async() => {
        setLoading(true)
        try{
            let count = update + 1
            const result = await axios.post(SDM_PAY_HOST + '/adminUpdateWithdrawalRequestStatus', {requestId: withdrawalRequest.id, updateStatus:updatedStatus, reference: reference, currency: withdrawalRequest.currency, userId: withdrawalRequest.userId, amount: withdrawalRequest.amount})
            console.log(result)
            if(result.status === 200){
                setUpdate(count)
                handleClose()
            }
            
        }
        catch(err){
            alert(err)
        }
        setLoading(false)
    }
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Update withdrawal request status</DialogTitle>
            <DialogContent>
            {/* <DialogContentText>
                
            </DialogContentText> */}
            <div>
                <Stack direction={'row'} spacing={1}>
                    <span style={{fontWeight: 'bold'}}>Request ID: </span>
                    <span>{withdrawalRequest.id}</span>
                </Stack>
                <Stack direction={'row'} sx={{mt:1}}>
                    <span style={{fontWeight: 'bold'}}>Requested Amount: </span>
                    <span>{withdrawalRequest.currency} ${withdrawalRequest.amount}</span>
                </Stack>
                <Stack direction={'row'} sx={{mt:1}}>
                    <span style={{fontWeight: 'bold'}}>Note: </span>
                    <span>{withdrawalRequest.note}</span>
                </Stack>
            </div>
            <div style={{marginTop: 10}}>
                <FormControl variant="filled" sx={{ minWidth: 200 }}>
                    <InputLabel id="demo-simple-select-filled-label">Status</InputLabel>
                    <Select
                        labelId="demo-simple-select-filled-label"
                        id="demo-simple-select-filled"
                        value={updatedStatus}
                        onChange={handleChange}
                    >
                        <MenuItem value={'pending'}>Pending</MenuItem>
                        <MenuItem value={'canceled'}>Canceled</MenuItem>
                        <MenuItem value={'complete'}>Complete</MenuItem>
                    </Select>
                </FormControl>
            </div>
            {updatedStatus === 'complete'? 
            <div style={{marginTop: 10}}>
                <TextField
                    id="outlined-controlled"
                    label="Reference"
                    value={reference}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setReference(event.target.value);
                    }}
                />
            </div>: null}
            
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancel</Button>
                {loading? 
                <LoadingButton
                    loading
                    loadingPosition="start"
                    startIcon={<SaveIcon />}
                    variant="outlined"
                >
                    Confirm
                </LoadingButton>
                :<Button onClick={() => onConfirmStatusChange()} disabled={updatedStatus === 'complete' && !reference}>Confirm</Button>}
            </DialogActions>
        </Dialog>
    );
}

export default WithdrawalStatusUpdateDialog;